import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-58f24fe8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "library-left-banner"
}, null, -1));
const _hoisted_3 = {
  class: "library-top-text1"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "library-title-span"
}, "企业", -1));
const _hoisted_5 = {
  class: "library-top-text2"
};
const _hoisted_6 = {
  class: "library-top-text1"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "library-title-span"
}, "个人", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "library-top-text2"
}, "欢迎使用腾讯电脑管家软件开放平台", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "library-left-banner"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _ctx.user.identityType == 2 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    style: _normalizeStyle({
      background: 'url(' + _ctx.companybg + ')'
    }),
    class: "library-top"
  }, [_renderSlot(_ctx.$slots, "default", {}, undefined, true), _createElementVNode("div", _hoisted_3, [_createTextVNode(_toDisplayString(_ctx.user.userName) + " ", 1), _hoisted_4]), _createElementVNode("div", _hoisted_5, "当前管理者 " + _toDisplayString(_ctx.user.vagueName), 1)], 4)) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    style: _normalizeStyle({
      background: 'url(' + _ctx.personbg + ')'
    }),
    class: "library-top"
  }, [_renderSlot(_ctx.$slots, "default", {}, undefined, true), _createElementVNode("div", _hoisted_6, [_createTextVNode(_toDisplayString(_ctx.user.vagueName) + " ", 1), _hoisted_7]), _hoisted_8], 4)), _hoisted_9]);
}